import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ikonIndikator } from "../../utils/indicatorIcon";
import React from "react";
import { Badge } from "react-bootstrap";
import { formatAngka, formatDelta } from "../../utils";

// Absolut dan intensitas sengaja disandingkan dalam satu tabel. Angka absolut
// selalu naik seiring pertumbuhan volume order sehingga tidak bisa dipakai
// menilai operasi; intensitas (per kg / per order) yang menunjukkan apakah
// operasi benar-benar membaik. Memisah keduanya ke halaman berbeda membuat
// pembaca menyimpulkan dari kolom yang salah.
function PanelKonsumsi({ items }) {
  if (!items || items.length === 0) {
    return (
      <div className="text-muted" style={{ fontSize: "12px" }}>
        Belum ada data konsumsi pada periode ini.
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table table-bordered align-middle mb-0" style={{ fontSize: "12px" }}>
        <thead className="table-light">
          <tr>
            <th rowSpan={2}>Indikator</th>
            <th colSpan={2} className="text-center bg-light">
              Absolut
            </th>
            <th colSpan={3} className="text-center bg-light">
              Intensitas
            </th>
            <th rowSpan={2} className="text-center">
              Tier
            </th>
          </tr>
          <tr>
            <th className="text-end">Total</th>
            <th className="text-end">Δ vs lalu</th>
            <th className="text-end">Per order</th>
            <th className="text-end">Per kg</th>
            <th className="text-end">Volume (kg)</th>
          </tr>
        </thead>
        <tbody>
          {items.map((val) => (
            <tr key={val.code}>
              <td>
                <div className="fw-bold">
                  <FontAwesomeIcon
                      icon={ikonIndikator(val.icon)}
                      className="me-2 text-secondary"
                    />
                  {val.nama}
                </div>
                <div className="text-muted" style={{ fontSize: "10px" }}>
                  {val.code} · {val.unit}
                </div>
              </td>
              <td className="text-end">{formatAngka(val.total)}</td>
              <td className="text-end">
                <span
                  className={
                    Number(val.delta_vs_prev) > 0 ? "text-danger" : "text-success"
                  }
                >
                  {formatDelta(val.delta_vs_prev)}
                </span>
              </td>
              <td className="text-end">{formatAngka(val.per_order, 3)}</td>
              <td className="text-end fw-bold">{formatAngka(val.intensity, 4)}</td>
              <td className="text-end">{formatAngka(val.total_weight_kg, 1)}</td>
              <td className="text-center">
                <Badge bg="secondary">{val.quality_tier || "-"}</Badge>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="text-muted mt-2" style={{ fontSize: "10px" }}>
        Kenaikan kolom Absolut belum tentu buruk bila volume order naik. Nilai pada
        kolom Intensitas yang menunjukkan efisiensi operasi sesungguhnya.
      </div>
    </div>
  );
}

export default PanelKonsumsi;
